import { API } from "./api";
import { randomUUID } from "./crypto";
import { deserialize, deserializeArray, serialize } from "./encoding";
import { Err, ErrorCode, isAbortError } from "./error";
const FAILED_CONNECTION_MESSAGE = "Die Applikation konnte keine Verbindung zum Pentacode Server herstellen. Bitte prüfen Sie Ihre Internetverbindung!";
async function send(url, req, { signal } = {}) {
    let text;
    try {
        const res = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(req),
            signal,
        });
        text = await res.text();
    }
    catch (e) {
        if (isAbortError(e)) {
            throw e;
        }
        throw new Err(ErrorCode.FAILED_CONNECTION, FAILED_CONNECTION_MESSAGE, { error: e });
    }
    try {
        return JSON.parse(text);
    }
    catch (e) {
        throw new Err(ErrorCode.SERVER_ERROR);
    }
}
export function createRpcClient(url, getClientInfo) {
    const client = {
        session: null,
        errorHandler: undefined,
        getClientInfo,
        async call(method, params, options) {
            const req = { method, params, id: randomUUID() };
            req.clientInfo = client.getClientInfo();
            if (client.session) {
                req.auth = { session: client.session.id, token: client.session.token };
            }
            let res;
            try {
                res = await send(url, req, options);
            }
            catch (e) {
                if (isAbortError(e)) {
                    throw e;
                }
                client.errorHandler && client.errorHandler(e);
                throw e;
            }
            if (res.error) {
                const err = new Err(res.error.code, res.error.message);
                client.errorHandler && client.errorHandler(err);
                throw err;
            }
            //clears potential errors after a successful request
            client.errorHandler && client.errorHandler(null);
            return res;
        },
    };
    const methods = client;
    for (const { method, output } of API.prototype.handlerDefinitions) {
        // the stub signature decides which argument is the payload; some handlers declare a
        // parameter without registering an input type, so the definition can't be used for this
        const takesParams = API.prototype[method].length > 0;
        methods[method] = async (...args) => {
            const input = takesParams ? args[0] : undefined;
            const options = args[takesParams ? 1 : 0];
            const res = await client.call(method, input ? [serialize(input)] : input, options);
            if (!res.result || !output) {
                return res.result;
            }
            if (Array.isArray(res.result)) {
                return deserializeArray(output, res.result);
            }
            return deserialize(output, res.result);
        };
    }
    return client;
}
//# sourceMappingURL=rpc-client.js.map